import {
  createRouter,
  createWebHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SobreView from '../views/SobreView.vue'
import PasseiosView from '../views/PasseiosView.vue'
import ContatoView from '../views/ContatoView.vue'

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Bonito XP | Agência de Turismo em Bonito MS',
      description: 'Monte o roteiro da sua viagem para Bonito MS e Pantanal. Os melhores passeios e pacotes promocionais em até 10x.'
    }
  },
  {
    path: '/sobre',
    name: 'sobre',
    component: SobreView,
    meta: {
      title: 'Sobre a Bonito XP | Agência de Turismo em Bonito MS',
      description: 'Conheça a Bonito XP: atendimento local, roteiros personalizados e experiências de ecoturismo em Bonito-MS.'
    }
  },
  {
    path: '/passeios',
    name: 'passeios',
    component: PasseiosView,
    redirect: '/passeios/categorias',
    children: [{
        path: 'categorias',
        name: 'categorias',
        component: () => import('../views/CategoriaView.vue'),
        meta: {
          title: 'Passeios em Bonito MS | Bonito XP',
          description: 'Conheça os passeios de Bonito-MS: flutuações, cachoeiras, grutas, balneários, aventuras e mergulhos com a Bonito XP.'
        }
      },
      {
        path: 'cachoeiras',
        name: 'cachoeiras',
        component: () => import('../views/passeios/CachoeiraView.vue'),
        meta: {
          title: 'Cachoeiras em Bonito MS | Bonito XP',
          description: 'Passeios de cachoeira em Bonito-MS: Boca da Onça, Ceita Corê, Estância Mimosa, Parque das Cachoeiras e mais.'
        }
      },
      {
        path: 'balnearios',
        name: 'balnearios',
        component: () => import('../views/passeios/BalnearioView.vue'),
        meta: {
          title: 'Balneários em Bonito MS | Bonito XP',
          description: 'Balneários em Bonito-MS: Nascente Azul, Praia da Figueira, Estrela do Formoso e opções de lazer para toda a família.'
        }
      },
      {
        path: 'flutuacoes',
        name: 'flutuacoes',
        component: () => import('../views/passeios/FlutuacaoView.vue'),
        meta: {
          title: 'Flutuações em Bonito MS | Bonito XP',
          description: 'Flutuação no Rio Sucuri, Rio da Prata, Gruta do Mimoso, Abismo Anhumas e outros passeios em águas cristalinas de Bonito-MS.'
        }
      },
      {
        path: 'aventuras',
        name: 'aventuras',
        component: () => import('../views/passeios/AventurasView.vue'),
        meta: {
          title: 'Aventuras em Bonito MS | Bonito XP',
          description: 'Boia-cross, rapel, arvorismo e quadriciclo em Bonito-MS. Passeios de aventura com a Bonito XP.'
        }
      },
      {
        path: 'bikes',
        redirect: {
          name: 'aventuras'
        }
      },
      {
        path: 'contemplacoes',
        name: 'contemplacoes',
        component: () => import('../views/passeios/ContemplacaoView.vue'),
        meta: {
          title: 'Passeios contemplativos em Bonito MS | Bonito XP',
          description: 'Buraco das Araras, Bio Park, barco elétrico e outros passeios contemplativos da fauna e flora de Bonito-MS.'
        }
      },
      {
        path: 'grutas',
        name: 'grutas',
        component: () => import('../views/passeios/GrutaView.vue'),
        meta: {
          title: 'Grutas em Bonito MS | Bonito XP',
          description: 'Gruta do Lago Azul, Abismo Anhumas, Gruta da Catedral e outros passeios em cavernas de Bonito-MS.'
        }
      },
      {
        path: 'mergulhos',
        name: 'mergulhos',
        component: () => import('../views/passeios/SubAquaticaView.vue'),
        meta: {
          title: 'Mergulhos em Bonito MS | Bonito XP',
          description: 'Mergulho e aventura subaquática em Bonito-MS: Anhumas, Gruta do Mimoso, Rio da Prata e Lagoa Misteriosa.'
        }
      },
      {
        path: 'cavalgadas',
        name: 'cavalgadas',
        component: () => import('../views/passeios/CavalgadaView.vue'),
        meta: {
          title: 'Cavalgadas e Pantanal | Bonito XP',
          description: 'Cavalgadas e passeios no Pantanal com a Bonito XP: fazendas, trilhas a cavalo e experiências na maior planície alagada do mundo.'
        }
      },
      {
        path: 'pantanal',
        redirect: {
          name: 'cavalgadas'
        }
      },
    ]
  },
  {
    path: '/pacotes',
    name: 'pacotes',
    component: () => import('../views/PacotesView.vue'),
    meta: {
      title: 'Pacotes para Bonito MS | Bonito XP',
      description: 'Pacotes de viagem para Bonito MS com passeios, hospedagem e roteiros personalizados. Parcelamento em até 10x.'
    }
  },
  {
    path: '/pacotes-bonitoms',
    name: 'pacotes-bonitoms',
    component: () => import('../views/PacotesView.vue'),
    meta: {
      title: 'Pacotes Bonito MS | Bonito XP',
      description: 'Pacotes promocionais para Bonito MS com a Bonito XP. Monte seu roteiro com os melhores passeios da região.'
    }
  },
  {
    path: '/contato',
    name: 'contato',
    component: ContatoView,
    meta: {
      title: 'Contato | Bonito XP Bonito MS',
      description: 'Fale com a Bonito XP e monte um roteiro personalizado para Bonito-MS. WhatsApp, e-mail e formulário de contato.'
    }
  },
  {
    path: '/hospedagem',
    name: 'hospedagem',
    component: () => import('../views/HospedagemView.vue'),
    meta: {
      title: 'Hospedagem em Bonito MS | Bonito XP',
      description: 'Encontre hospedagem em Bonito-MS com a Bonito XP. Pousadas e opções para completar o roteiro da sua viagem.'
    }
  },
  // {
  //   path: '/categoria',
  //   name: 'categoria',
  //   component: CategoriaView,
  // },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const GA_ID = 'G-VJ2ZQHWBDD'
const SITE_URL = 'https://bonitoxp.com.br'

function canonicalUrl(path) {
  if (!path || path === '/') {
    return `${SITE_URL}/`
  }
  const clean = path.split('?')[0].replace(/\/$/, '')
  return `${SITE_URL}${clean}/`
}

function updateSeoTags(to) {
  const url = canonicalUrl(to.path)
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.description) {
    let description = document.querySelector('meta[name="description"]')
    if (!description) {
      description = document.createElement('meta')
      description.setAttribute('name', 'description')
      document.head.appendChild(description)
    }
    description.setAttribute('content', to.meta.description)
  }
}

router.afterEach((to) => {
  updateSeoTags(to)

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }

  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_ID, {
      page_path: to.fullPath
    })
  }
})

export default router